<template>
  <van-col
    class="itserve-center history-search-page round-shadow-btn"
    span="24"
  >
    <van-row>
      <van-col span="24" class="date-block mt-25 apply-loader">
        {{ $t("components.searchEntry.setIndicationFrom") }}
      </van-col>
      <van-col span="24">
        <CustomDatePicker v-model="dates.dateFrom" class="apply-loader" />
      </van-col>
      <van-col span="24" class="date-block apply-loader">
        {{ $t("components.searchEntry.setIndicationsTo") }}
      </van-col>
      <van-col span="24">
        <CustomDatePicker v-model="dates.dateTo" class="apply-loader" />
      </van-col>
      <template
        v-if="dates.dateFrom !== null && dates.dateTo !== null && !pickerActive"
      >
        <itserve-button
          :value="$t('components.searchEntry.find')"
          type="primary"
          @click="openSearchPage"
          class="mt-15 mb-25 apply-loader"
        ></itserve-button>
      </template>
    </van-row>
  </van-col>
</template>

<script>
import ItserveButton from "@/components/forms/ItserveButton";
import "vue-awesome/icons/calendar-alt";
import "vue-awesome/icons/search";
import CustomDatePicker from "@/components/helpers/CustomDatePicker";

export default {
  name: "IndicationsHistorySearchForm",
  components: {
    CustomDatePicker,
    ItserveButton,
  },
  data() {
    return {
      maxDate: new Date(),
      pickerType: null,
      pickerActive: false,
      dates: {
        dateFrom: null,
        dateTo: null,
      },
    };
  },
  created() {
    this.dates.dateFrom = this.getDate(true);
    this.dates.dateTo = this.getDate();
  },
  methods: {
    getDate(monthBack = false) {
      let date = new Date();
      if (monthBack) {
        date.setMonth(
          date.getMonth() - process.env.VUE_APP_HISTORY_SEARCH_MONTHBACK
        );
        return date;
      } else {
        return date;
      }
    },
    formatDate(date) {
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return `${day < 10 ? "0" + day : day}.${
        month < 10 ? "0" + month : month
      }.${date.getFullYear()}`;
    },
    switchPicker(type) {
      this.selectedDate = this.dates[type];
      this.pickerType = type;
      this.pickerActive = !this.pickerActive;
    },
    setDate(date) {
      this.dates[this.pickerType] = new Date(date);
      this.switchPicker(null);
    },
    cancelDate() {
      this.switchPicker(null);
    },

    openSearchPage() {
      let dateFrom = new Date(this.dates.dateFrom).getTime();
      let dateTo = new Date(this.dates.dateTo).getTime();
      if (dateTo < dateFrom) {
        this.dates.dateFrom = [
          this.dates.dateTo,
          (this.dates.dateTo = this.dates.dateFrom),
        ][0];
      }

      let searchQuery = {
        start_date: this.formatDate(this.dates.dateFrom),
        end_date: this.formatDate(this.dates.dateTo),
        ls: this.$route.params.account,
      };

      this.$store.commit("IndicationsHistory/SET_FILTER_VALUES", searchQuery);
      this.$router.push({
        name: "IndicatorsHistorySearchResults",
        params: searchQuery,
      });
    },
  },
};
</script>

<style scoped>
@import "../../../node_modules/vant/lib/picker/index.css";
@import "../../../node_modules/vant/lib/cell/index.css";
@import "../../../node_modules/vant/lib/popup/index.css";

.absolute-title {
  position: absolute;
  z-index: 9999;
  width: 100%;
  top: 44px;
}
.date-block {
  padding: 10px;
  min-height: 39px;
  text-align: center;
  color: #918dab;
}
.history-search-page {
  padding-left: 12px;
  padding-right: 12px;
}
.green-btn {
  background-color: #1aad62;
}
</style>
<style>
.changed-buttons .van-picker__toolbar {
  margin-bottom: 64px;
}

.van-picker__confirm {
  background-color: #2e73b4;
  color: #fff;
  margin-top: 10px;
  margin-right: 15px;
  height: 30px;
  margin-left: 5px;
}
.van-picker__cancel {
  background-color: #2e73b4;
  color: #fff;
  margin-top: 10px;
  margin-left: 15px;
  height: 30px;
  margin-right: 5px;
}
</style>
